import { createContext } from 'react'

/**
 * True inside `<Table.Head>`, so `<Table.Cell>` renders `<th scope="col">`.
 *
 * Context rather than a separate HeadCell component keeps migrations mechanical:
 * one Cell works in both sections, exactly as MUI's TableCell did.
 */
export const TableHeadContext = createContext(false)
